import React, { FC, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
} from "@mui/material";
import { TestType, TestTypeData } from "../types/interface";

interface TestTypeDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: TestTypeData) => void;
}

/**
 * Dialog for selecting test type (Internal/External) before export.
 * Internal mode requires an email address.
 */
const TestTypeDialog: FC<TestTypeDialogProps> = ({ open, onClose, onConfirm }) => {
  const [testType, setTestType] = useState<TestType>(TestType.INTERNAL);
  const [email, setEmail] = useState("");

  const handleConfirm = () => {
    onConfirm({
      type: testType,
      email: testType === TestType.INTERNAL ? email.trim() || undefined : undefined,
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 600 }}>Testtyp auswählen</DialogTitle>
      <DialogContent>
        <DialogContentText>Bitte wählen Sie den Testtyp für den Export.</DialogContentText>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <RadioGroup
            row
            value={testType}
            onChange={(e) => setTestType(e.target.value as TestType)}
          >
            <FormControlLabel value={TestType.INTERNAL} control={<Radio />} label="Internal" />
            <FormControlLabel value={TestType.EXTERNAL} control={<Radio />} label="External" />
          </RadioGroup>
        </Box>

        {testType === TestType.INTERNAL && (
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mt: 1 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button onClick={handleConfirm} variant="contained">
          Einreichen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TestTypeDialog;
